







































import _ from "lodash";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import formatNumber from '@/shared/filters/format-number';
import formatDate from '@/shared/filters/format-date';
import { APP_CONFIG } from '@/config/app-config';
import voucherServices from '@/services/voucher-services';
@Component({
    components: {
        VuePerfectScrollbar
    }
})
export default class Voucher extends Vue {
    @Prop({default: false})
    private modalDialog: boolean;
    @Prop({default: 0})
    private order_id: number;
    @Prop({default: 1})
    private order_type: number;
    @Prop({default: 0})
    private uid: number;
    @Prop({default: null})
    private user_name: string;
    @Prop({default: null})
    private order_code: string;

    get availableVouchers() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].availableVouchers;
    }

    private onChangeVoucher(item) {
        if(item.OrderID > 0) {
            item.OrderID = 0;
            item.OrderType = 0;
        }
        else {
            item.OrderID = this.order_id; 
            item.OrderType = this.order_type;
        }
    }

    private voucherContent(voucher) {
        let feeObject = voucher.FeeObj ? JSON.parse(voucher.FeeObj) : [];
        let feeObjectStr = '';
        for (let i = 0; i < feeObject.length; i++) {
            const element = feeObject[i];
            if(element.enabled) {
                feeObjectStr += `<li>${element.name}</li>`;
            }
        }
        let html = `
        <span>Mã giảm giá: <b>${voucher.Code}</b></span><br>
        <span>Giá trị: <b>${formatNumber(voucher.Amount, '0,0')}</b></span><br>
        <span class='text-danger'><b>Điều kiện áp dụng:</b></span><br>
        <span>- Thời gian: ${formatDate(voucher.StartDate, 'DD/MM/YYYY')} - ${formatDate(voucher.EndDate, 'DD/MM/YYYY')}</span><br>
        <span>- Tiền hàng tối thiểu: ${formatNumber(voucher.MinAmount, '0,0')} (đối với đơn mua hộ)</span><br>
        <span>- Phí vận chuyển tối thiểu: ${formatNumber(voucher.MinAmountDeposit, '0,0')} (đối với đơn ký gửi)</span><br>
        <span>- Các loại phí:</span><br>
        <ul>
        ${feeObjectStr}
        </ul>
        `;
        return html;
    }

    private closePopup() {
        this.$emit("closePopup");
    }

    private async acceptModal() {
        let selectedVoucher = _.filter(this.availableVouchers, p => {return p.OrderID === this.order_id});
        for (let i = 0; i < selectedVoucher.length; i++) {
            let feeObject1 = _.filter(selectedVoucher[i].FeeObj ? JSON.parse(selectedVoucher[i].FeeObj) : [], {'enabled': true});
            for (let j = 0; j < selectedVoucher.length; j++) {
                let feeObject2 = _.filter(selectedVoucher[j].FeeObj ? JSON.parse(selectedVoucher[j].FeeObj) : [], {'enabled': true});
                if(selectedVoucher[i].ID != selectedVoucher[j].ID && _.filter(feeObject1, n => { return _.find(feeObject2, p => { return p.name == n.name && p.enabled == n.enabled; })}).length > 0) {
                    Vue.notify({ duration: 8000, group: 'foo', type: 'error', title: 'Thông báo!', text: 'Những Voucher bạn vừa chọn bị trùng lặp các loại phí áp dụng trên đơn hàng. Thay vì chọn nhiều, bạn hãy thử chọn 1 Voucher áp dụng trên đơn này để có số tiền giảm trừ nhiều nhất.' });
                    return;
                }
            }
        }
        const result = await voucherServices.applyVoucher({order_id: this.order_id, order_type: this.order_type, uid: this.uid, user_name: this.user_name, order_code: this.order_code, voucher_ids: _.map(selectedVoucher, 'ID')});
        if (result && result.data && result.data.status === 200) {
            Vue.notify({ group: 'foo', type: 'success', title: 'Thông báo!', text: 'Cập nhật đơn hàng thành công!' });
        }
        this.$emit("acceptModal");
    }
}

